import _createForOfIteratorHelper from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { TAG_NAMES as $, NS, hasUnescapedText } from '../common/html.js';
import { escapeText, escapeAttribute } from 'entities/lib/escape.js';
import { defaultTreeAdapter } from '../tree-adapters/default.js';
// Sets
var VOID_ELEMENTS = new Set([$.AREA, $.BASE, $.BASEFONT, $.BGSOUND, $.BR, $.COL, $.EMBED, $.FRAME, $.HR, $.IMG, $.INPUT, $.KEYGEN, $.LINK, $.META, $.PARAM, $.SOURCE, $.TRACK, $.WBR]);
function isVoidElement(node, options) {
  return options.treeAdapter.isElementNode(node) && options.treeAdapter.getNamespaceURI(node) === NS.HTML && VOID_ELEMENTS.has(options.treeAdapter.getTagName(node));
}
var defaultOpts = {
  treeAdapter: defaultTreeAdapter,
  scriptingEnabled: true
};
/**
 * Serializes an AST node to an HTML string.
 *
 * @example
 *
 * ```js
 * const parse5 = require('parse5');
 *
 * const document = parse5.parse('<!DOCTYPE html><html><head></head><body>Hi there!</body></html>');
 *
 * // Serializes a document.
 * const html = parse5.serialize(document);
 *
 * // Serializes the <html> element content.
 * const str = parse5.serialize(document.childNodes[1]);
 *
 * console.log(str); //> '<head></head><body>Hi there!</body>'
 * ```
 *
 * @param node Node to serialize.
 * @param options Serialization options.
 */
export function serialize(node, options) {
  var opts = _objectSpread(_objectSpread({}, defaultOpts), options);
  if (isVoidElement(node, opts)) {
    return '';
  }
  return serializeChildNodes(node, opts);
}
/**
 * Serializes an AST element node to an HTML string, including the element node.
 *
 * @example
 *
 * ```js
 * const parse5 = require('parse5');
 *
 * const document = parse5.parseFragment('<div>Hello, <b>world</b>!</div>');
 *
 * // Serializes the <div> element.
 * const html = parse5.serializeOuter(document.childNodes[0]);
 *
 * console.log(str); //> '<div>Hello, <b>world</b>!</div>'
 * ```
 *
 * @param node Node to serialize.
 * @param options Serialization options.
 */
export function serializeOuter(node, options) {
  var opts = _objectSpread(_objectSpread({}, defaultOpts), options);
  return serializeNode(node, opts);
}
function serializeChildNodes(parentNode, options) {
  var html = '';
  // Get container of the child nodes
  var container = options.treeAdapter.isElementNode(parentNode) && options.treeAdapter.getTagName(parentNode) === $.TEMPLATE && options.treeAdapter.getNamespaceURI(parentNode) === NS.HTML ? options.treeAdapter.getTemplateContent(parentNode) : parentNode;
  var childNodes = options.treeAdapter.getChildNodes(container);
  if (childNodes) {
    var _iterator = _createForOfIteratorHelper(childNodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var currentNode = _step.value;
        html += serializeNode(currentNode, options);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return html;
}
function serializeNode(node, options) {
  if (options.treeAdapter.isElementNode(node)) {
    return serializeElement(node, options);
  }
  if (options.treeAdapter.isTextNode(node)) {
    return serializeTextNode(node, options);
  }
  if (options.treeAdapter.isCommentNode(node)) {
    return serializeCommentNode(node, options);
  }
  if (options.treeAdapter.isDocumentTypeNode(node)) {
    return serializeDocumentTypeNode(node, options);
  }
  // Return an empty string for unknown nodes
  return '';
}
function serializeElement(node, options) {
  var tn = options.treeAdapter.getTagName(node);
  return "<".concat(tn).concat(serializeAttributes(node, options), ">").concat(isVoidElement(node, options) ? '' : "".concat(serializeChildNodes(node, options), "</").concat(tn, ">"));
}
function serializeAttributes(node, _ref) {
  var treeAdapter = _ref.treeAdapter;
  var html = '';
  var _iterator2 = _createForOfIteratorHelper(treeAdapter.getAttrList(node)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var attr = _step2.value;
      html += ' ';
      if (!attr.namespace) {
        html += attr.name;
      } else switch (attr.namespace) {
        case NS.XML:
          {
            html += "xml:".concat(attr.name);
            break;
          }
        case NS.XMLNS:
          {
            if (attr.name !== 'xmlns') {
              html += 'xmlns:';
            }
            html += attr.name;
            break;
          }
        case NS.XLINK:
          {
            html += "xlink:".concat(attr.name);
            break;
          }
        default:
          {
            html += "".concat(attr.prefix, ":").concat(attr.name);
          }
      }
      html += "=\"".concat(escapeAttribute(attr.value), "\"");
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return html;
}
function serializeTextNode(node, options) {
  var treeAdapter = options.treeAdapter;
  var content = treeAdapter.getTextNodeContent(node);
  var parent = treeAdapter.getParentNode(node);
  var parentTn = parent && treeAdapter.isElementNode(parent) && treeAdapter.getTagName(parent);
  return parentTn && treeAdapter.getNamespaceURI(parent) === NS.HTML && hasUnescapedText(parentTn, options.scriptingEnabled) ? content : escapeText(content);
}
function serializeCommentNode(node, _ref2) {
  var treeAdapter = _ref2.treeAdapter;
  return "<!--".concat(treeAdapter.getCommentNodeContent(node), "-->");
}
function serializeDocumentTypeNode(node, _ref3) {
  var treeAdapter = _ref3.treeAdapter;
  return "<!DOCTYPE ".concat(treeAdapter.getDocumentTypeNodeName(node), ">");
}